@if (visible()) {
  <div
    data-testid="staff-access-banner"
    role="status"
    aria-label="Blume staff view"
    class="pad-safe-area-top fixed inset-x-0 top-0 z-[9999] flex justify-center px-3 pointer-events-none"
  >
    <div
      class="mt-2 flex max-w-[calc(100vw-1.5rem)] items-center gap-2 rounded-full border border-outline-high bg-surface-high px-3 py-1.5 theme-shadow"
    >
      <app-icon name="eye-outline" color="warning" size="sm" aria-hidden="true"></app-icon>
      <span class="truncate text-xs font-semibold text-body">
        BLUME STAFF VIEW
        @if (districtName(); as name) {
          <span class="font-normal text-muted">&middot; {{ name }}</span>
        }
      </span>
    </div>
  </div>
}
